import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { formatTranslation, userRoleLabelKey } from 'intl';
import { CommonTranslationKeys } from 'intl/keys';
import { IntlShape } from 'react-intl';
import { DataGridColumnsFactory } from 'components/common/dataGrid/columnsFactory';
import { UserOnView } from 'shared/domain/user/types/view';
import { ListCellWithModal } from 'components/common/dataGrid/columnsFactory/cellRenderers/listCellWithModal';
import { Typography } from '@mui/material';
import { ELLIPSIS_TEXT_SX } from 'components/common/dataGrid/styles';
import { FiltersTranslationKeys } from 'intl/keys';

export class UserColumnsFactory extends DataGridColumnsFactory<UserOnView> {
  constructor(intl: IntlShape, timezone: string) {
    super(intl, timezone);
  }

  private readonly renderUserPhoneCell = (
    params: GridRenderCellParams<UserOnView>
  ) => {
    return (
      <Typography variant='body2' sx={ELLIPSIS_TEXT_SX}>
        {params.row.phone || '-'}
      </Typography>
    );
  };

  private readonly renderUserRoleCell = (
    params: GridRenderCellParams<UserOnView>
  ) => {
    return (
      <Typography variant='body2' sx={ELLIPSIS_TEXT_SX}>
        {formatTranslation(this.intl, userRoleLabelKey(params.row.role._id))}
      </Typography>
    );
  };

  private readonly renderUserProcessesCell = (
    params: GridRenderCellParams<UserOnView>
  ) => {
    const processes = params.row.processes || params.value || [];
    return (
      <ListCellWithModal
        items={Array.isArray(processes) ? processes : []}
        label={formatTranslation(this.intl, CommonTranslationKeys.process)}
      />
    );
  };

  private readonly renderUserSitesCell = (
    params: GridRenderCellParams<UserOnView>
  ) => {
    const sites = params.row.sites || params.value || [];
    return (
      <ListCellWithModal
        items={Array.isArray(sites) ? sites : []}
        label={formatTranslation(this.intl, FiltersTranslationKeys.filterTypeSite)}
      />
    );
  };

  create(): GridColDef<UserOnView>[] {
    return [
      this.orderNumber(),
      this.userLabel(),
      this.userEmail(),
      {
        ...this.userPhone(),
        renderCell: this.renderUserPhoneCell,
      },
      {
        ...this.userRole(),
        renderCell: this.renderUserRoleCell,
      },
      {
        ...this.userProcesses(),
        align: 'left',
        headerAlign: 'left',
        renderCell: this.renderUserProcessesCell,
      },
      {
        ...this.userSites(),
        align: 'left',
        headerAlign: 'left',
        renderCell: this.renderUserSitesCell,
      },
    ];
  }
}
